<div>
    Eingewählt als: {{ user?.username }}
    <button mat-raised-button type="button" (click)="logout()">
        Logout
    </button>
</div>
